export enum Authority {
  ADMIN = 'ROLE_ADMIN',
  USER = 'ROLE_USER',
  CONTROLER = 'ROLE_CONTROLER',
}

/**
 * Profils autorisés à extraire les données en masse (exports Excel/Word des REX, DCC et études FIAB) : les analystes,
 * parmi lesquels des prestataires externes, en sont exclus. Aligné sur AuthoritiesConstants.CAN_EXTRACT côté serveur.
 */
export const EXTRACT_AUTHORITIES = ['ROLE_ADMIN', 'ROLE_CONTROLER', 'ROLE_EXPERT', 'ROLE_GTD'];
